import { AuditMatch, DateStr, Station, toDateRange, today } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { AdsMatchesForm } from './AdsMatchesForm';
import { AdsMatchesList } from './AdsMatchesList';
import { AdsMatchesListing } from './types';

type Props = {
  station: Station;
};

export function AdsMatchesView(p: Props) {
  const tz = useTimezone();

  return (
    <ReportView<AdsMatchesListing>
      runOnLoad
      queryParamsTransform={{
        customId: {
          parse: (input) => input.split(',').map((customId) => ({ customId })),
          serialize: (input) => input.map((v) => v.customId).join(','),
        },
      }}
      defaultValues={{
        ...toDateRange(today() as DateStr, tz),
        customId: [],
      }}
      download={false}
      reportFn={async (values) => {
        const { results, metadata } = await apiClient.audit.fetchMatches({
          stationId: p.station.id,
          filter: {
            from: values.from,
            to: values.to,
            customId: (values.customId || []).map(({ customId }) => customId).join(','),
          },
          pageSize: 9999,
        });

        const matches: AuditMatch[] = [...results].sort((m1, m2) =>
          new Date(m1.datetime) >= new Date(m2.datetime) ? -1 : 1,
        );

        return {
          results: matches,
          total: metadata.totalCount,
        };
      }}
      Form={AdsMatchesForm}
      Result={AdsMatchesList}
    />
  );
}
